const navigationSk = {
    "menu_editor": "Menu",
    "settings": "Nastavenia",
    "payment_settings": "Nastavenia platieb",
    "user_management": "Správa používateľov",
    "logout": "Odhlásiť sa",
    "subscription": "Predplatné",
    "new_restaurant": "Vytvoriť novú reštauráciu",
    "privacy_policy": "Zásady ochrany osobných údajov",
    "terms_and_conditions": "Zmluvné podmienky",
    "statistics": "Štatistiky",
    "mozrest": "Manažér recenzií",
    "signup": "Zaregistrovať sa"
};

export default navigationSk;
